"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFillerHeight = useFillerHeight;
const react_1 = require("react");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 3 Nov 2026 · HOW TALL ONE FILLER ROW IS, SO A SHORT PAGE STANDS AS TALL    │
 * │ AS A FULL ONE.                                                             │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The product owner: the last page of a paged list is shorter, so the table shrank and the pager
 * jumped out from under the mouse. `pageFiller` says how many rows are missing; this says how tall
 * each one is.
 *
 * ⚠️⚠️ **MEASURED, NOT ASSUMED 34PX.** A row with a second line, a progress bar or an avatar is
 * taller than the list's base row, and fillers at 34px would leave the page short by exactly the
 * difference the reader came to stop seeing. The height is the average of the real rows.
 *
 * ⚠️ **A full page's rows win over the short page's own.** Whenever nothing is missing, the average
 * is remembered; on the short page that figure is used, so the page comes out the height the full
 * one had rather than the height its three rows happen to suggest. Reached directly — a link to the
 * last page — there is no full page yet, and the short page's own rows are the best estimate.
 *
 * ⚠️ jsdom has no layout: every height is 0 and the fallback stands.
 */
function useFillerHeight(container, selector, filler, fallback) {
    const full = (0, react_1.useRef)(null);
    const [height, setHeight] = (0, react_1.useState)(fallback);
    (0, react_1.useLayoutEffect)(() => {
        const root = container.current;
        if (root === null)
            return;
        const heights = Array.from(root.querySelectorAll(selector))
            .map((one) => one.getBoundingClientRect().height)
            .filter((one) => one > 0);
        if (heights.length === 0)
            return;
        const average = heights.reduce((sum, one) => sum + one, 0) / heights.length;
        if (filler === 0) {
            full.current = average;
            return;
        }
        const target = full.current ?? average;
        /* ⚠️ The guard is what keeps an effect with no dependency list from looping. */
        if (Math.abs(target - height) > 0.5)
            setHeight(target);
    });
    return height;
}
//# sourceMappingURL=filler-height.js.map